<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import VueButton from "vue-button";

export default {
  mixins: [fandomBasicMixin],
  components: {
    VueButton
  }, 
  props: ["content", "align", "col"],
  methods: {
    alignTextToJustify: Fandom.alignTextToJustify,
    getTarget: Fandom.getTarget,
  },
  computed: {
    columnClasses() {
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : this.col ? this.col : Fandom.retrieveFromGlobalState("one_col_text_width", 8);
      return [
        `col-lg-${columnWidth}`
      ];
    },
  }
};
</script>

<template>
  <div class="container my-4"  v-if="content.title || content.subtitle || content.description" stripe-title>
    <div class="row" :class="`justify-content-md-${alignTextToJustify(align)}`">
      <div :class="[columnClasses, `text-${align ? align : 'center'}`, {'mx-auto': align == 'center' || !align}]">
        <img v-if="content.icon" class="icon my-4" :style="{'width': content.icon_width}" :alt="content.icon.alt" :src="content.icon.url">
        <p class="category" v-if="content.category">{{content.category}}</p>
        <component v-if="content.title && !content.url" :is="content.title_tag || 'h2'" class="h1">{{content.title}}</component>
        <a v-if="content.title && !!content.url" :href="content.url.url" :target="getTarget(content.url)">
          <component :is="content.title_tag || 'h2'" class="h1">{{content.title}}</component>
        </a>
        <component v-if="content.subtitle" :is="content.subtitle_tag || 'h3'" class="h2">{{content.subtitle}}</component>
        <component v-if="content.description" :is="content.description_tag || 'p'" v-html="content.description"></component>
        <vue-button
          tag="a"
          class="my-4"
          v-if="content.button" 
          :button="content.button"
          :buttonClass="['btn shadow-none', getPrimaryButtonClass(content.button_class, content.theme)]"
        ></vue-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[stripe-title] {
  .icon {
    max-width: 100%;
    width: 9rem;
  }
}
</style>